<template>
  <div class="pt-3 px-3 pb-1">
           
      <p v-if="emails.length == 0" class="text-center">No emails sent</p>

        <span v-else >

       <!-- Desktop -->
        <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="20%">{{total}}</th>
                  <th class="pl-3" width="20%">Subject</th>
                  <th class="pl-3" width="15%">Status</th>
                  <th class="first-right px-3" width="15%">Date</th>
                </tr>
              </thead>
              <tbody>
    <tr class="body" v-for="(email, index) in emails" :key="index" @click="showModal(email)">
        <td class="pl-3">
          <div>{{ truncate(email.name) }}</div>
          <div><small>{{ truncate(email.email) }}</small></div>
          </td>
        <td class="pl-3">{{ truncate(email.subject) }}</td>
        <td class="pl-3">{{ truncate(email.status) }}</td>
        <td class="pl-3"><timeago
        :datetime="email.created_at"
        :auto-update="60"
        :title="formatDateMoment(email.updated_at)"></timeago></td>
    </tr>
              </tbody>
            </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Name • Email • Subject</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(email, index) in emails" :key="index">
  
        <td class="body pl-2 text-center">
            <div><b>{{ truncate(email.name) }}</b></div>
            <div>{{ truncate(email.email) }}</div>
            <div>{{ truncate(email.subject) }}</div>
            <div><timeago
                  :datetime="email.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(email.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </span>
<view-email :email="emailInfo"></view-email>
          </div>

</template>

<script>
export default {
  props: ['search_term'],

  watch: {
    search_term: function (val) {
      this.getEmails();
    }
  },

  data() {
    return {
      emails: [],
      emailInfo: {},
      loading: false,
      total: 0,
    };
  },

  created() {
    this.getEmails();

    Echo.private("contacts")
      .listen("UpdateEmails", (event) => {
        this.getEmails();
      });
  },

  methods: {

    showModal(email) {
      this.emailInfo = email;
      this.$bvModal.show("bv-modal-view-email");
    },

    // truncate string to 60 characters
    truncate(string) {
        const max = 45;
      if (string.length > max)
        return string.substring(0, max) + ' ...';
      else
        return string;
    },

    getEmails() {

      this.loading = true;

      axios
        .post('/contacts/emails', {
          search_term: this.search_term,
        })
        .then((response) => {
          this.emails = response.data.emails;
          this.total = response.data.total;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },

  },
};
</script> 

<style scoped>

</style>